import React from "react";

const ChartFrame = ({ 
  children, 
  aspect = 16 / 9, 
  minHeight = 220, 
  maxHeight = 420, 
  fixedHeight 
}) => {
  if (fixedHeight) {
    return (
      <div style={{ height: fixedHeight }} className="w-full">
        {children}
      </div>
    );
  }

  return (
    <div 
      className="w-full relative"
      style={{ 
        minHeight,
        maxHeight,
        aspectRatio: aspect 
      }}
    >
      {children}
    </div>
  );
};

export default ChartFrame;
